import { Page } from "../components/page/Page";
import { useTranslation } from "react-i18next";

export const MyPage2 = () => {
    const { t } = useTranslation();

    return (
        <Page title={t("mypage2")} description={t("mypage2IntroMessage")}>
            <p>最小構成、検証用</p>
        </Page>
  );
};

export default MyPage2;
